import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  Action,
  MutationUpdateSubscriptionIntervalArgs,
} from '@tribeplatform/gql-client/types'

import { useQueryClient } from '../../index.js'
import {
  useMutation,
  type UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getSubscriptionInformationKey } from '../../utils/keys/billing.js'

export const useUpdateSubscriptionInterval = (options?: {
  useMutationOptions?: UseMutationOptions<
    Action,
    ClientError,
    MutationUpdateSubscriptionIntervalArgs
  >
}) => {
  const { useMutationOptions } = options || {}
  const queryClient = useQueryClient()
  const { client } = useTribeClient()

  return useMutation<
    Action,
    ClientError,
    MutationUpdateSubscriptionIntervalArgs
  >(
    input =>
      client.mutation({
        name: 'updateSubscriptionInterval',
        args: {
          fields: 'basic',
          variables: input,
        },
      }),
    {
      onSettled: () => {
        queryClient.invalidateQueries(getSubscriptionInformationKey())
      },
      ...useMutationOptions,
    },
  )
}
